import React, { Component } from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import {MESSAGE, EDIT_MODE} from "../../../../../../wpconfig"

import * as func from "../../../../../../utils/functions";

import * as Actions from "../../../../../../store/modules/resources";
import * as FActions from "../../../../../../store/modules/footer";

import Item from './item'

class RecruitmentForm extends Component {
  constructor(props) {
    super(props);

		this.state = {
			pnu_data: [],
			editIndex : '',
			pkKey : 'scholar_career_id'
		}
  }

  componentDidMount() {
		func.getData("admin/scholar/" + func.getParams("record_id") + "/career", {}).then((response) => {
      let pnuData = (response.record.filter(f => f.career_kind === "pnu"))
			this.setState({
        pnu_data : pnuData
      });
		});

		this.onInsert = this.onInsert.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onRemove = this.onRemove.bind(this);
		this.onEditIndex = this.onEditIndex.bind(this);
		this.showMessage = this.showMessage.bind(this);
  }

	onInsert() {
		const record = this.state.pnu_data;

		if (record.length > 0 && record[0][this.state.pkKey] === '') {
			this.showMessage('추가해주세요.')
		} else {
			const insertRecord = {
        "career_kind": "pnu",
        "career_org": "",
        "start_yyyymm": "",
        "end_yyyymm": "",
        "career_role": "",
        "open_yn": "",
        "scholar_id": "",
        "scholar_career_id": "",
				"is_edit" : EDIT_MODE.SHOW_EDIT,
			}
			this.onEditIndex(0);
      // 데이터 변환 체크하기
			record.unshift(insertRecord)
      this.setState({ pnu_data : record })
		}
	}

	onUpdate(index, item, render) {
		const record = this.state.pnu_data
		record[index] = item
    this.setState({ pnu_data : record })
		if(render)
			this.forceUpdate();
	}

	onRemove(index) {
		const record = this.state.pnu_data
		record.splice(index, 1);
    this.setState({ pnu_data : record })
		this.forceUpdate();
	}

	onEditIndex(id) {
		if(this.state.editIndex)
			this.refs["ref" + this.state.editIndex].onClose();
		else if(this.refs.ref)
			this.refs.ref.onClose();
		else if(this.refs["ref" + this.state.editIndex])
			this.refs["ref" + this.state.editIndex].onClose();

		this.setState({
			'editIndex' : id
    })
	}

	showMessage(message) {
		this.props.fDataActions.setFooter({
			'isNoticePopup': true,
			'noticeMessage': message
		})
		setTimeout(() => {
			this.props.fDataActions.setFooter({
				'isNoticePopup': false,
				'noticeMessage': ''
			})
		}, 3000);
	}

  onChange = (e) => {
    console.log(e);
  };

  render() {
    return (
      <>
        <div className="d-flex justify-content-end mb-1">
          <h5 className="flex-grow-1 font-weight-bold align-bottom mt-3 mb-1">PNU 임용 정보</h5>
          <button type="button" className="btn btn-sm btn-primary" style={{"margin" : "10px" , "marginRight" : "0px"}} onClick={this.onInsert}>추가</button>
        </div>
        <table className="wp-list-table widefat fixed striped editable scholar-pnu">
          <colgroup>
            <col width="35px"/>
            <col width="100px"/>
            <col width="100px"/>
            <col width="100px"/>
            <col width=""/>
            <col width="200px"/>
            <col width="100px"/>
            <col width="110px"/>
          </colgroup>
          <thead>
            <tr>
              <th scope="col"><input type="checkbox" className="ml-0" /></th>
              <th scope="col">NO</th>
              <th scope="col">임용일자</th>
              <th scope="col">퇴직일자</th> 
              <th scope="col">소속</th>
              <th scope="col">역할</th>
              <th scope="col">공개여부</th>
              <th scope="col">수정</th>
            </tr>
          </thead>
          <tbody>
            {
              this.state.pnu_data.map((data, idx) => {
                return (
                  <Item 
                    key={data[this.state.pkKey]}
                    index={data[this.state.pkKey]}
                    ref={"ref" + data[this.state.pkKey]}
                    pkKey={this.state.pkKey}
                    arrIndex={idx}
                    record={data}
                    onUpdate={this.onUpdate}
                    onRemove={this.onRemove}
                    onEditIndex={this.onEditIndex}
                    showMessage={this.showMessage}
                  />
                )
              })
            }
          </tbody>
        </table>
      </>
    )
  }
}

export default connect(
	(state) => ({
		record: state.scholars.record ? state.scholars.record : {},
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch),
		fDataActions: bindActionCreators(FActions, dispatch)
	}),
) (RecruitmentForm)
